import React from 'react';
import { Result } from 'antd';

export default function ResubscribeSuccess() {
  return (
    <Result
      status="success"
      subTitle="Your re-subscription to emails from Turing was successful. You will continue to receive emails from Turing!"
      title="Resubscribed Successfully"
    />
  );
}
